// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App container */
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  justify-content: flex-start;
}

/* Input Section - Flexbox layout for horizontal arrangement */
.input-section {
  position: relative; /* This makes the dropdown position relative to the input field */
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  max-width: 600px; /* Increased max-width for a larger section */
  justify-content: space-between; /* Optionally, add space between input and button */
}

#city-input {
  padding: 15px; /* Increased padding to make the input box larger */
  width: 100%; /* Make input take full width of the container */
  font-size: 1.2rem; /* Increase font size for better readability */
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box; /* Ensures padding doesn't affect total width */
}

#get-weather-btn {
  padding: 15px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px; /* Space between input and button */
}

#get-weather-btn:hover {
  background-color: #2980b9;
}

/* City drop down menu for input */
#city-dropdown {
  display: block;
  position: absolute; /* Position it absolutely within the .input-section */
  top: 100%; /* Position it directly below the input field */
  left: 0; /* Align it to the left edge of the input field */
  background-color: rgb(227, 196, 196);
  border: 1px solid #ccc;
  max-height: 200px;
  width: 100%; /* Ensure the dropdown takes up the full width of the input field */
  z-index: 100;
  box-sizing: border-box;
  overflow-y: auto;
}

#city-dropdown li {
  list-style: none;
  padding: 8px;
  cursor: pointer;
}

#city-dropdown li:hover {
  width: 100%;
  background-color: #f0f0f0;
}

#get-weather-btn {
  padding: 2px 20px;
  cursor: pointer;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
}

/* Styling for the title */
.weather-container h1 {
  font-size: 2rem; /* Make the title bigger */
  margin-bottom: 20px; /* Add some margin below the title to space it from the grid */
  text-align: center;
  color: #333;
}

/* Weather Container - CSS Grid */
.weather-container {
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(100px, 1fr)
  ); /* Responsive grid */
  gap: 20px;
  padding: 20px;
  width: 100%;
  max-width: 1000px;
}

/* Weather Day Div - Styling for each weather card */
.weather-day-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.convert-units-btn {
  margin-bottom: 15px;
  padding: 8px 15px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
}

/* Typography for the Date */
.weather-date {
  font-size: 1.2rem; /* Slightly larger font */
  font-weight: bold; /* Emphasize the date */
  color: #333;
  margin-bottom: 10px;
  z-index: 1;
}

.weather-temperature {
  font-size: 1em;
  margin: 5px 0;
  color: #555;
  z-index: 1;
}

/* Conditions Description */
.weather-description {
  font-size: 1rem;
  color: #333;
  margin-top: 10px;
  z-index: 1;
}

/* Video Background Handling */
.weather-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  z-index: 0; /* Push video behind the content */
  opacity: 0.5; /* Reduce intensity for readability */
}

.weather-day-div {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between; /* Evenly distribute content */
  background: linear-gradient(135deg, #e0f7fa, #a5e0e5); /* Subtle gradient */
  border: 1px solid #ccc;
  border-radius: 12px; /* Rounded edges for a modern look */
  padding: 20px; /* Spacious padding for better content separation */
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4); /* Add depth */
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease; /* Smooth hover effects */
  overflow: hidden; /* Ensure video doesn't exceed bounds */
}

.weather-day-div:hover {
  transform: scale(1.05); /* Subtle zoom on hover */
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2); /* Emphasize hover effect */
}

/* Media Query - For smaller screens */
@media (max-width: 600px) {
  .input-section {
    width: 100%;
    max-width: 300px;
  }

  #city-input {
    padding: 15px; /* Increased padding to make the input box larger */
    width: 100%; /* Make input take full width of the container */
    font-size: 0.75rem; /* Increase font size for better readability */
    border: 1px solid #ccc;
    border-radius: 7px;
    box-sizing: border-box; /* Ensures padding doesn't affect total width */
  }

  #city-input,
  #city-dropdown,
  #get-weather-btn {
    width: 90%; /* Make inputs and button take more space */
  }

  #get-weather-btn {
    font-size: 0.7rem;
    padding: 10px 5px;
    width: 4rem;
    border-radius: 7px;
  }
  .weather-container {
    grid-template-columns: 1fr; /* Stack weather cards on small screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/sample.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB,EAAE,iEAAiE;EACrF,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAE,6CAA6C;EAC/D,8BAA8B,EAAE,mDAAmD;AACrF;;AAEA;EACE,aAAa,EAAE,mDAAmD;EAClE,WAAW,EAAE,gDAAgD;EAC7D,iBAAiB,EAAE,8CAA8C;EACjE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB,EAAE,+CAA+C;AACzE;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,kBAAkB,EAAE,qDAAqD;EACzE,SAAS,EAAE,+CAA+C;EAC1D,OAAO,EAAE,iDAAiD;EAC1D,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;EACjB,WAAW,EAAE,mEAAmE;EAChF,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe,EAAE,0BAA0B;EAC3C,mBAAmB,EAAE,8DAA8D;EACnF,kBAAkB;EAClB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb;;;GAGC,EAAE,oBAAoB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB,EAAE,yBAAyB;EAC5C,iBAAiB,EAAE,uBAAuB;EAC1C,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,UAAU,EAAE,kCAAkC;EAC9C,YAAY,EAAE,qCAAqC;AACrD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B,EAAE,8BAA8B;EAC9D,qDAAqD,EAAE,oBAAoB;EAC3E,sBAAsB;EACtB,mBAAmB,EAAE,oCAAoC;EACzD,aAAa,EAAE,mDAAmD;EAClE,kBAAkB;EAClB,yCAAyC,EAAE,cAAc;EACzD;;wBAEsB,EAAE,yBAAyB;EACjD,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,sBAAsB,EAAE,yBAAyB;EACjD,yCAAyC,EAAE,2BAA2B;AACxE;;AAEA,sCAAsC;AACtC;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa,EAAE,mDAAmD;IAClE,WAAW,EAAE,gDAAgD;IAC7D,kBAAkB,EAAE,8CAA8C;IAClE,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB,EAAE,+CAA+C;EACzE;;EAEA;;;IAGE,UAAU,EAAE,2CAA2C;EACzD;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B,EAAE,yCAAyC;EACvE;AACF","sourcesContent":["/* App container */\n#app {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  justify-content: flex-start;\n}\n\n/* Input Section - Flexbox layout for horizontal arrangement */\n.input-section {\n  position: relative; /* This makes the dropdown position relative to the input field */\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  width: 100%;\n  max-width: 600px; /* Increased max-width for a larger section */\n  justify-content: space-between; /* Optionally, add space between input and button */\n}\n\n#city-input {\n  padding: 15px; /* Increased padding to make the input box larger */\n  width: 100%; /* Make input take full width of the container */\n  font-size: 1.2rem; /* Increase font size for better readability */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box; /* Ensures padding doesn't affect total width */\n}\n\n#get-weather-btn {\n  padding: 15px;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px; /* Space between input and button */\n}\n\n#get-weather-btn:hover {\n  background-color: #2980b9;\n}\n\n/* City drop down menu for input */\n#city-dropdown {\n  display: block;\n  position: absolute; /* Position it absolutely within the .input-section */\n  top: 100%; /* Position it directly below the input field */\n  left: 0; /* Align it to the left edge of the input field */\n  background-color: rgb(227, 196, 196);\n  border: 1px solid #ccc;\n  max-height: 200px;\n  width: 100%; /* Ensure the dropdown takes up the full width of the input field */\n  z-index: 100;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n#city-dropdown li {\n  list-style: none;\n  padding: 8px;\n  cursor: pointer;\n}\n\n#city-dropdown li:hover {\n  width: 100%;\n  background-color: #f0f0f0;\n}\n\n#get-weather-btn {\n  padding: 2px 20px;\n  cursor: pointer;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n}\n\n/* Styling for the title */\n.weather-container h1 {\n  font-size: 2rem; /* Make the title bigger */\n  margin-bottom: 20px; /* Add some margin below the title to space it from the grid */\n  text-align: center;\n  color: #333;\n}\n\n/* Weather Container - CSS Grid */\n.weather-container {\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fill,\n    minmax(100px, 1fr)\n  ); /* Responsive grid */\n  gap: 20px;\n  padding: 20px;\n  width: 100%;\n  max-width: 1000px;\n}\n\n/* Weather Day Div - Styling for each weather card */\n.weather-day-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 15px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.convert-units-btn {\n  margin-bottom: 15px;\n  padding: 8px 15px;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n\n/* Typography for the Date */\n.weather-date {\n  font-size: 1.2rem; /* Slightly larger font */\n  font-weight: bold; /* Emphasize the date */\n  color: #333;\n  margin-bottom: 10px;\n  z-index: 1;\n}\n\n.weather-temperature {\n  font-size: 1em;\n  margin: 5px 0;\n  color: #555;\n  z-index: 1;\n}\n\n/* Conditions Description */\n.weather-description {\n  font-size: 1rem;\n  color: #333;\n  margin-top: 10px;\n  z-index: 1;\n}\n\n/* Video Background Handling */\n.weather-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  z-index: 0; /* Push video behind the content */\n  opacity: 0.5; /* Reduce intensity for readability */\n}\n\n.weather-day-div {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between; /* Evenly distribute content */\n  background: linear-gradient(135deg, #e0f7fa, #a5e0e5); /* Subtle gradient */\n  border: 1px solid #ccc;\n  border-radius: 12px; /* Rounded edges for a modern look */\n  padding: 20px; /* Spacious padding for better content separation */\n  text-align: center;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4); /* Add depth */\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease; /* Smooth hover effects */\n  overflow: hidden; /* Ensure video doesn't exceed bounds */\n}\n\n.weather-day-div:hover {\n  transform: scale(1.05); /* Subtle zoom on hover */\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2); /* Emphasize hover effect */\n}\n\n/* Media Query - For smaller screens */\n@media (max-width: 600px) {\n  .input-section {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  #city-input {\n    padding: 15px; /* Increased padding to make the input box larger */\n    width: 100%; /* Make input take full width of the container */\n    font-size: 0.75rem; /* Increase font size for better readability */\n    border: 1px solid #ccc;\n    border-radius: 7px;\n    box-sizing: border-box; /* Ensures padding doesn't affect total width */\n  }\n\n  #city-input,\n  #city-dropdown,\n  #get-weather-btn {\n    width: 90%; /* Make inputs and button take more space */\n  }\n\n  #get-weather-btn {\n    font-size: 0.7rem;\n    padding: 10px 5px;\n    width: 4rem;\n    border-radius: 7px;\n  }\n  .weather-container {\n    grid-template-columns: 1fr; /* Stack weather cards on small screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
